import { RepViewColumnId } from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';
import type { SortingState } from '@tanstack/react-table';

export const NAME_COLUMN_PERCENTAGE = 46;
export const DEFAULT_COLUMN_WIDTH_PERCENTAGE = 18;
export const MIN_NAME_COLUMN_SIZE = 240;
export const MIN_COLUMN_SIZE = 120;
export const ESTIMATED_HEADER_HEIGHT = 40;
export const ROW_HEIGHT = 65;

export const DEFAULT_SORTING: SortingState = [
  { desc: false, id: RepViewColumnId.Name },
];
